//短时间内，需要根据系统做出界面上不同的处理，所以设置这个文件作为key的存储

export const APP={
  SHILISHOU:'实力瘦',
  QINGBULUO:'轻部落',
}

